<template>
  <div class="p-grid p-fluid">
    <div class="p-col-2">
      <input
        style="display:none"
        type="file"
        id="file"
        ref="file"
        v-on:change="handleFileUpload()"
      />
      <Panel header="Pdf">
        <Button
          class="p-button-success"
          style="width: 100%"
          icon="pi pi-file-pdf"
          label="Seleccionar Pdf"
          @click="this.$refs.file.click()"
        ></Button>
      </Panel>

      <Panel header="Campos">
        <Button
          class="p-button-success"
          style="width: 100%"
          icon="pi pi-tag"
          label="Agregar campo"
          @click="handleCreateField"
        ></Button>
        <Button
          class="p-button-success"
          style="width: 100%"
          icon="pi pi-tag"
          label="Detectar campos"
          @click="detectarCampos"
        ></Button>
        <Button
          class="p-button-success"
          style="width: 100%"
          icon="pi pi-tag"
          label="Eliminar todos los campos"
          @click="handleDeleteAllFields"
        ></Button>

        <div class="pspdfkit-menu p-mt-2">
          <div
            class="p-d-flex p-flex-row"
            v-for="field in fields"
            v-bind:key="field.id"
          >
        
            <Button @click="selectField(field.id)">
              {{ field.name }}
            </Button>
            <Button 
              @click="handleFieldDelete(field.id)" 
              class="p-button-danger p-button-sm"
              icon="pi pi-trash"
              style="min-width: 40px; height: 40px;"
              title="Eliminar campo"
            ></Button>
          </div>
        </div>
      </Panel>

      <Panel header="Propiedades del formulario">      
        <div class="p-field" v-if="this.currentField">             
          <label for="empresa">Tipo</label>
          <Dropdown
            id="type"
            :options="types"
            optionLabel="name"
            optionValue="value"
            v-model="currentField.type"
            @change="handleLFieldChange"
          ></Dropdown>        
        </div>        
        <div class="p-field" v-if="this.currentField">             
          <label for="long">Largo del campo</label>
          <Dropdown
            id="long"
            :options="LONGS"
            optionLabel="name"
            optionValue="value"
            v-model="currentField.long"
            @change="handleLFieldChange"
          ></Dropdown>         
        </div>
        <div class="p-field" v-if="this.currentField">              
          <label for="validation">Opciones</label>
          <Textarea
            id="options"
            :autoResize="true"
            rows="3" 
            v-model="currentField.options"
            @change="handleLFieldChange"
          ></Textarea>        
        </div>
        <div class="p-field" v-if="this.currentField">           
          <label for="label">Etiqueta</label>
          <InputText
            id="label"
            v-model="currentField.label"
            @change="handleLFieldChange"
          ></InputText>        
        </div>
        <div class="p-field" v-if="this.currentField">           
          <label for="format">Formato</label>
          <InputText
            id="format"
            v-model="currentField.format"
            @change="handleLFieldChange"
          ></InputText>        
        </div>
        <div class="p-field" v-if="this.currentField">              
          <label for="validation">Validación</label>
          <InputText
            id="validation"
            v-model="currentField.validation"
            @change="handleLFieldChange"
          ></InputText>        
        </div>
      </Panel>
    </div>
    <div class="p-col-10">
      <div
        id="pspdfkit-container"
        class="pspdfkit-container"
        style="height: 100vh"
      ></div>
    </div>
  </div>
</template>
<script>

import { v4 as uuidv4 } from 'uuid';
import { apiDelete, apiGet, apiPost, apiPostForm } from '../helpers/rest-api';
import { getUrlBack } from '../helpers/urls';



let PSPDFKit = null


// Use the public directory URL as a base URL. PSPDFKit will download its library assets from here.
const baseUrl = getUrlBack();

/**
 * PSPDFKit for Web example component
 */
export default {
  //name: 'PSPDFKit',
  data() {
    return { 
             fields: [], 
             document: '' , 
             currentField: null,
             currentsField: [],
             types: [
                {name: 'Texto' , value: 'String'},
                {name: 'Número' , value: 'Number'}, 
                {name: 'Fecha'   , value: 'Date'}, 
                {name: 'Si/No', value: 'Boolean'},
                {name: 'Lista', value: 'List'}
              ],
              LONGS: [
                {name: '1'       , value: 1 },
                {name: '2'       , value: 2 },
                {name: '3'       , value: 3 },
                {name: '4'       , value: 4 },
                {name: '5'       , value: 5 },
                {name: '6'       , value: 6 },
                {name: '7'       , value: 7 },
                {name: '8'       , value: 8 },
                {name: '9'       , value: 9 },
                {name: '10'      , value: 10},
                {name: '11'      , value: 11},
                {name: '12'      , value: 12}                
              ],
            };
              
  },
  /**
   * The component receives these parameters:
   * @documentUrl: string — URL of the document to be loaded.
   * @baseUrl: string — URL from which the PSPDFKit library should get its payload and artifacts
   */
  props: ['plantillaId'],

  _instance: null,
  /**
   * We wait until the template has been rendered to load the document into the library.
   */
  mounted() {
      /*
    console.log('mounted');
    if (!window.PSPDFKit) {
      const script = document.createElement('script')
      script.src = 'https://cdn.cloud.pspdfkit.com/pspdfkit.js'
      script.onload = this.load
      document.head.appendChild(script);
      console.log('script ok');
      PSPDFKit = window.PSPDFKit;
      
    } else {
      PSPDFKit = window.PSPDFKit;
      console.log('script load ok');
      this.load()
    }
    */

    PSPDFKit = window.PSPDFKit;
  },

  created() {
    apiGet('field/plantilla/' + this.plantillaId).then((response) => {
      this.fields = response.data;
    });

    apiGet('plantilla/' + this.plantillaId).then((response) => {
      this.document = response.data.documentUrl;
    });
  },
  /**
   * Our component has these two methods — one to trigger document loading, and the other to unload and clean up
   * so the component is ready to load another document.
   */
  methods: {
    load: function load() {
      if (this.document && this.document !== null && this.document !== '') {
        const documentUrl = baseUrl + this.document;

        console.log('cargando...', documentUrl);

        PSPDFKit.unload(this._instance || '.pspdfkit-container');
        
        PSPDFKit.load({
          //baseUrl: baseUrl,
          document: documentUrl,
          container: '.pspdfkit-container',

        }).then((instance) => {
          instance.addEventListener(
            'annotations.update',
            this.handleAnnotationsUpdate
          );
          instance.addEventListener(
            'annotations.delete',
            this.handleAnnotationsDelete
          );

          this._instance = instance;

          // SI VIENE DEL PDF NO SE CREAN LAS ANOTACIONES
          //   this.fields.forEach((field) => this.createAnnotation(field));
        }).catch((error) => {
          console.error('Error al cargar el documento:', error);
        });
      } else {
        this.unload();
      }
    },
    unload: function unload() {
      if (this._instance) {
        PSPDFKit.unload(this._instance || '.container');
        this._instance = null;
      }
    },

    async handleFieldDelete(fieldId) {
      try {
        // Confirmar eliminación
        //if (!confirm('¿Estás seguro de que quieres eliminar este campo?')) {
        //  return;
       // }

        // Eliminar de la API
        await apiDelete('field/' + fieldId);
        
        // Eliminar de la instancia de PSPDFKit si existe
        /*
        if (this._instance) {
          const annotation = this._instance.getAnnotationById(fieldId);
          if (annotation) {
            this._instance.delete(annotation);
          }
        }
          */
        
        // Eliminar del array local
        const fieldIndex = this.fields.findIndex(f => f.id === fieldId);
        if (fieldIndex > -1) {
          this.fields.splice(fieldIndex, 1);
        }
        
        // Limpiar currentField si era el campo seleccionado
        if (this.currentField && this.currentField.id === fieldId) {
          this.currentField = null;
        }
        
        console.log('Campo eliminado:', fieldId);
      } catch (error) {
        console.error('Error al eliminar campo:', error);
        alert('Error al eliminar el campo');
      }
    },

    async handleAnnotationsDelete(annotations) {

      const id = annotations.first().id;

      const field = this.fields.find((e)=> e.pdfId === id);

      if (field) {
        this.fields = this.fields.filter((e)=> e.id !== id);
        apiDelete('field/' + field.id);
      }

    },

    handleAnnotationsUpdate(annotations) {
      let editedAnnotation = annotations.first();

      var _left = Math.round(editedAnnotation.boundingBox.left);
      var _top = Math.round(editedAnnotation.boundingBox.top); // OJO !!!  + 12 + 2;
      var id = editedAnnotation.id;

      if (editedAnnotation instanceof PSPDFKit.Annotations.TextAnnotation) {
        var field = this.fields.find((e) => e.id === id);

        field.name = editedAnnotation.text.toUpperCase();
        field.left = _left;
        field.top = _top;

        var object = {
          ...field,
          idPlantilla: this.plantillaId,
        };

        apiPost('field', JSON.stringify(object));
      }
    },

    selectField(id) {
      console.log('selectField', id);
      this._instance.setSelectedAnnotation(id);
     


      this.currentField = this.fields.find((e) => e.id === id);

      // const current = this._instance.getSelectedAnnotation();
      // if (current)
      //	this._instance.setPageIndex(current.page, true)
    },

    handleCreateField() {

      const id = uuidv4();
      const leftInitital = 100;
      const topInitital = 100;
      const field = {
        id: id,
        pdfId: '',
        name: 'SIN NOMBRE',
        type: 'String',
        left: leftInitital,
        top: topInitital,
        idPlantilla: this.plantillaId,
        long: 1,
        label: 'SIN NOMBRE',
        format: '',
        validation: '',
        page: this._instance.viewState.currentPageIndex,
      };

      apiPost('field', JSON.stringify(field));

      this.fields.push(field);

      this.createAnnotation(field);
    },
    createAnnotation(field) {
      this._instance.create(
        new PSPDFKit.Annotations.TextAnnotation({
          id: field.id,
          page: field.page,
          text: field.name,
          fontSize: 12,
          backgroundColor: PSPDFKit.Color.LIGHT_YELLOW,
          ontColor: PSPDFKit.Color.BLACK,
          opacity: 0.6,
          boundingBox: new PSPDFKit.Geometry.Rect({
            left: field.left,
            top: field.top,
            width: 100,
            height: 12,
          }),
        })
      );
    },
    handleFileUpload() {
      let formData = new FormData();
      formData.append('file', this.$refs.file.files[0]);
      formData.append('plantillaId', this.plantillaId);

      apiPostForm('plantilla/upload', formData).then((response) => {
        this.document = response.data.documentUrl;
      });
    },
    handleLFieldChange() {
      apiPost('field', JSON.stringify(this.currentField));
    },
    async detectarCampos() {

      
      const fields = await this._instance.getFormFields();

      const pageCount = this._instance.totalPageCount

      const widgets = []

      for (let i = 0; i < pageCount; i++) {
        const annotations = await this._instance.getAnnotations(i)
        const pageWidgets = annotations.filter(
          ann => ann instanceof PSPDFKit.Annotations.WidgetAnnotation
        )

        pageWidgets.forEach(widget => {
          const field = fields.find(f => f.name === widget.formFieldName)

          console.log('field detectado',field.name, field);
         // console.log('widget', widget);

          if (field) {
            widgets.push({
              id:  uuidv4(),
              pdfId: field.id,
              name: field.name,
              label: field.label,
              type: 'String', //field.constructor.name,
              value: field.value,
              page: i,
              left: widget.boundingBox.left,
              top: widget.boundingBox.top,
              width: widget.boundingBox.width,
              height: widget.boundingBox.height
            })
          }
        })
      }


      widgets.sort((a, b) => {
        if (a.page !== b.page) return a.page - b.page
        if (a.top !== b.top) return a.top - b.top // más arriba = mayor Y (PDF usa coord. invertidas)
        return a.left - b.left
      })

     // console.log('sorteded widgets', widgets);

      this.fields = widgets;

      
      widgets.forEach((field, index)  => {
        //console.log('creando field', field, index);
        this.createField(field, index);
      });

    },
    handleDeleteAllFields() {
      this.fields.forEach(field => {
        apiDelete('field/' + field.id);
      });
      this.fields = [];
    },

    createField(fieldPDF, index) {

      const field = {
        id: fieldPDF.id,
        pdfId: fieldPDF.pdfId,
        name: fieldPDF.name,
        type: 'String',
        left: parseInt(fieldPDF.left, 10),
        top: parseInt(fieldPDF.top, 10),
        width: parseInt(fieldPDF.width, 10),
        height: parseInt(fieldPDF.height, 10),
        idPlantilla: this.plantillaId,
        long:  this.nameToLong(fieldPDF.name),
        label: fieldPDF.label,
        format: '',
        validation: '',
        page: fieldPDF.page,
        order: index
      };

     //console.log('field', field);
     
      apiPost('field', JSON.stringify(field));
    },
    nameToLong(name) {
      if (name.includes('Fecha')) {
        return 2;
      }
      if (name.includes('Número')) {
        return 3;
      }

      return 4;
    }
  },
  /**
   * We watch for `documentUrl` prop changes and trigger unloading and loading when there's a new document to load.
   */
  watch: {
    document: function documentUrl() {
      this.unload();
      this.load();
    },
  },
  /**
   * Clean up when the component is unmounted (not needed in this example).
   */
  beforeUnmount: function beforeDestroy() {
    this.unload();
  },
};
</script>
